<template>
    <div class="opt-overview-bar-wrapper">
        <div class="options-sel">
            <div>
                <span class="channel-search">{{ quesChannel }} :</span>
                <ChannelSelect value="all" @change="channelSelect" />
            </div>
            <div>{{ language }} : <LangSelect value="all" class="lang-select" @change="langSelect" :requireAll="true"></LangSelect></div>
        </div>

        <div class="panel-title-timegroup">
            <TimePicker :pickData="pickData" @timeChange="setTimeRanger" :currentPicked="currentPicked"></TimePicker>
            <MultiCalendar
                dateFormat="YYYY/MM/DD"
                @dateSelect="dateSelectHanlder"
                :value="curDates"
                :disableRanges="disableRanges"
                :pickSameDay="true"
            ></MultiCalendar>
        </div>
    </div>
</template>

<script>
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import LangSelect from "@/components/langSelect";
import MultiCalendar from "@/views/zhiji/bComponents/calendar/MultiCalendar";
import TimePicker from "@/views/zhiji/bComponents/switchs/TimePicker";

export default {
    name: "OptOverviewBar",
    components: {
        LangSelect,
        MultiCalendar,
        TimePicker,
        ChannelSelect
    },
    data() {
        return {
            curDates: null,
            currentPicked: 0,
            disableRanges: [
                {
                    start: new Date(Date.now()) // 今天不可选
                }
            ]
        };
    },
    mounted() {
        this.curDates = this.getCurrentDates();
        this.$emit("timeChange", [this.zhiji.dateFormat(this.curDates[0], "YYYY/MM/DD"), this.zhiji.dateFormat(this.curDates[0], "YYYY/MM/DD")]);
    },
    computed: {
        pickData() {
            return [
                {
                    label: this.$t("zhiji.dataPanel.yesterday"),
                    value: 1
                },
                {
                    label: this.$t("zhiji.dataPanel.sevenDays"),
                    value: 7
                },
                {
                    label: this.$t("zhiji.dataPanel.thirtyDays"),
                    value: 30
                }
            ];
        },
        quesChannel() {
            return this.$t("zhiji.overview.quesChannel");
        },
        language() {
            return this.$t("zhiji.common.language");
        }
    },
    methods: {
        langSelect(data) {
            this.$emit("langSelect", {
                value: data
            });
        },
        channelSelect(data) {
            this.$emit("channelSelect", {
                value: data
            });
        },
        setTimeRanger(dateStrs) {
            let start = Date.parse(dateStrs[0]) - getDayMilliseconds() * 1;
            let end = Date.parse(dateStrs[1]) - getDayMilliseconds() * 1;
            this.curDates = [new Date(start), new Date(end)];
            this.$emit("timeChange", [this.zhiji.dateFormat(new Date(start), "YYYY/MM/DD"), this.zhiji.dateFormat(new Date(end), "YYYY/MM/DD")]);
        },
        dateSelectHanlder(dates) {
            this.currentPicked = -1;
            this.curDates = dates;
            this.$emit("timeChange", [this.zhiji.dateFormat(dates[0], "YYYY/MM/DD"), this.zhiji.dateFormat(dates[1], "YYYY/MM/DD")]);
        },
        getCurrentDates() {
            let yesterday = new Date(Date.now() - getDayMilliseconds() * 1);
            return [yesterday, yesterday];
        }
    }
};

// 一天的秒数
function getDayMilliseconds() {
    return 24 * 60 * 60 * 1000;
}
</script>

<style lang="scss" scoped>
.opt-overview-bar-wrapper {
    height: 67px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;

    div {
        margin-right: 20px;
        display: flex;
        align-items: center;

        .select {
            margin-left: 10px;
        }
    }

    .panel-title-timegroup {
        margin-right: 0px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .multi-calendar {
        margin-right: 0px;
    }
    .panel-time-select {
        margin-bottom: 0 !important;
    }
    .channel-search {
        width: 66px;
    }
    .lang-select {
        margin-left: 12px;
        width: 120px;
    }
}
</style>
